import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AuxiliaryEquipmentTopHead from './auxiliary-equipment-top-head';
import AuxiliaryEquipmentContent from './auxiliary-equipment-content';
import AuxiliaryEquipmentModals from './auxiliary-equipment-modals';
import { actions as auxiliaryEquipmentActions, fetchAuxiliaryEquipmentsWithFilters } from './store/slice';

const { resetFilters } = auxiliaryEquipmentActions;

const AuxiliaryEquipmentView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAuxiliaryEquipmentsWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Auxiliary Equipment</h4>
              </div>
            </div>
            <AuxiliaryEquipmentTopHead />
          </div>
          <AuxiliaryEquipmentContent />
          <AuxiliaryEquipmentModals />
        </div>
      </div>
    </div>
  );
};

export default AuxiliaryEquipmentView;
